'use es6';

import { enableES5 } from 'immer';
enableES5();